import { Injectable, inject } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";
import { AsyncValidator, registerAsyncValidatorDecorator } from "@recursyve/ngx-form-generator";
import { isDefined } from "@recursyve/nice-ts-utils";
import { Observable, of, timer } from "rxjs";
import { map, switchMap } from "rxjs/operators";

import { ApiService } from "../../../../../../api/api.service";

export function SupplierNameIsUnique(): PropertyDecorator {
    return registerAsyncValidatorDecorator({
        name: "SupplierNameIsUniqueValidator"
    });
}

@Injectable()
export class SupplierNameIsUniqueValidator extends AsyncValidator {
    private readonly apiService = inject(ApiService);

    public readonly name = "SupplierNameIsUniqueValidator";

    public validate(control: AbstractControl): Observable<ValidationErrors | null> {
        const controlValue: unknown = control.value;
        if (!isDefined(controlValue) || typeof controlValue !== "string" || controlValue === "") {
            return of(null);
        }

        return timer(200).pipe(
            switchMap(() =>
                this.apiService.suppliers.nameExists(controlValue).pipe(
                    map((isNewSupplierNameValid) => {
                        if (!isNewSupplierNameValid) {
                            control.markAsTouched();
                            return { supplier_name_already_used: true };
                        }

                        return null;
                    })
                )
            )
        );
    }
}
